import { render } from "./PaymentsView.vue?vue&type=template&id=3b93578a"
import script from "./PaymentsView.vue?vue&type=script&lang=js"
export * from "./PaymentsView.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "3b93578a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b93578a', script)) {
    api.reload('3b93578a', script)
  }
  
  module.hot.accept("./PaymentsView.vue?vue&type=template&id=3b93578a", () => {
    api.rerender('3b93578a', render)
  })

}

script.__file = "src/views/payments/PaymentsView.vue"

export default script